import React from "react";
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from "@/components/ui/table";
import { Database } from "lucide-react";

export default function ResultsGrid({ columns, rows }) {
  if (!columns || columns.length === 0) {
    return <p className="text-sm text-slate-400 flex items-center gap-2 py-6" data-testid="sql-results-empty"><Database className="w-4 h-4" /> Run a query to see results here.</p>;
  }
  return (
    <div className="overflow-auto max-h-96 rounded-lg border border-white/10" data-testid="sql-results-grid">
      <Table>
        <TableHeader>
          <TableRow className="border-white/10 hover:bg-transparent">
            {columns.map((c, i) => <TableHead key={`${i}-${c}`} className="text-indigo-300 font-bold whitespace-nowrap">{c}</TableHead>)}
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.map((row, ri) => (
            <TableRow key={ri} className="border-white/5 hover:bg-white/5">
              {row.map((cell, ci) => <TableCell key={ci} className="text-slate-300 whitespace-nowrap">{cell === null ? <span className="text-slate-400">NULL</span> : String(cell)}</TableCell>)}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
